// should be the same as in launchDarkly UI flag 'key' value
export enum FeatureFlags {
  PLACEHOLDER = 'placeholder',
  LP_4114_STALE_CHUNK_FIX = 'lp-4114-stale-chunk-fix',
}
